import { useEffect, useState } from "react";
import { getPosts } from "../api/feedApi";
import PostCard from "../components/PostCart";

export default function Feed({ category, refresh }) {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPosts();
  }, [category, refresh]);

  const fetchPosts = async () => {
    try {
      setLoading(true);

      const data = await getPosts(category);

      setPosts(data);
    } catch (err) {
      console.error("Error fetching posts", err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="text-center py-10 text-gray-500">
        Loading posts...
      </div>
    );
  }

  if (!posts.length) {
    return (
      <div className="bg-white/50 backdrop-blur-xl rounded-2xl p-8 text-center border border-white/60">
        <h3 className="text-lg font-semibold text-gray-700">
          No posts yet
        </h3>

        <p className="text-sm text-gray-500 mt-2">
          Be the first to post in this Kalp.
        </p>
      </div>
    );
  }

  return (
    <div className="mt-4 space-y-4">
      {posts.map((p) => (
        <PostCard key={p.id} post={p} />
      ))}
    </div>
  );
}